import groq from "groq"

export async function getDefectReferences(client, selectedDefects) {
  const selectedDefectIds = selectedDefects?.map((defect) => defect?.id) ?? []

  const defects = await client.fetch(groq`*[_type=="complaintAvailableDefects" && _id in $selectedDefectIds]`, {
    selectedDefectIds,
  })

  return defects?.map((defect) => {
    return { _type: "reference", _ref: defect._id, _key: defect._id, _weak: true }
  })
}

export async function getApplicationReferences(client, selectedApplications) {
  const selectedApplicationsIds = selectedApplications?.map((application) => application?.id) ?? []

  const applications = await client.fetch(
    groq`*[_type=="complaintAvailableApplications" && _id in $selectedApplicationsIds]`,
    {
      selectedApplicationsIds,
    },
  )

  return applications?.map((application) => {
    return { _type: "reference", _ref: application._id, _key: application._id, _weak: true }
  })
}

export async function getClaimReferences(client, selectedClaims) {
  const selectedClaimsIds = selectedClaims?.map((claim) => claim?.id) ?? []

  const claims = await client.fetch(groq`*[_type=="complaintCustomerClaims" && _id in $selectedClaimsIds]`, {
    selectedClaimsIds,
  })

  return claims?.map((claim) => {
    return { _type: "reference", _ref: claim._id, _key: claim._id, _weak: true }
  })
}

export function getAttachmentReferences(attachments) {
  const results = []
  for (const attachment of attachments) {
    const type = attachment?.mimetype?.startsWith("image/") ? "image" : "file"

    if (attachment?.id) {
      const { id, ...rest } = attachment
      results.push({ _key: id, _type: `${type}Reference`, ...rest })
    }
  }
  return results
}
